<template>
    <div class="md:w-5/6 lg:w-3/4 xl:w-2/3 mx-auto">
        <form
            ref="form"
            action="/user/shipment-batches/search"
            method="POST"
            @keydown.enter="onSubmit(form)"
            @submit.prevent="onSubmit(form)"
        >
            <div
                class="mt-4 bg-white py-5 px-4 sm:rounded-lg sm:shadow-md sm:border sm:border-gray-200 sm:p-6"
            >
                <div class="md:grid md:grid-cols-2 md:gap-6">
                    <div class="mt-0 md:col-span-2">
                        <input type="hidden" name="_token" :value="csrf" />

                        <div class="grid grid-cols-6 gap-6">
                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="start"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Start Date
                                </label>
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <datepicker
                                        :weekStartsOn="0"
                                        v-model="inputs.start"
                                        :ref="refs.start"
                                        id="start"
                                        name="start"
                                        :class="[
                                            hasError(errors, 'start')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'start')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'start')
                                                ? 'start-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="hasError(errors, 'start')"
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'start')"
                                    class="mt-2 text-sm text-red-600"
                                    id="start-error"
                                >
                                    {{ error(errors, "start") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="end"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    End Date
                                </label>
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <datepicker
                                        :weekStartsOn="0"
                                        v-model="inputs.end"
                                        :ref="refs.end"
                                        id="end"
                                        name="end"
                                        :class="[
                                            hasError(errors, 'end')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'end')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'end')
                                                ? 'end-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        v-if="hasError(errors, 'end')"
                                        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'end')"
                                    class="mt-2 text-sm text-red-600"
                                    id="end-error"
                                >
                                    {{ error(errors, "end") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="status"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Status
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <select
                                        v-model="inputs.status"
                                        :ref="refs.status"
                                        id="status"
                                        name="status"
                                        :class="[
                                            hasError(errors, 'status')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-14'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'status')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'status')
                                                ? 'status-error'
                                                : ''
                                        "
                                    >
                                        <option value="" selected>All</option>
                                        <option
                                            v-for="(
                                                statusOption, statusOptionId
                                            ) in statusOptions"
                                            :key="statusOptionId"
                                            :value="statusOptionId"
                                        >
                                            {{ statusOption }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="hasError(errors, 'status')"
                                        class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'status')"
                                    class="mt-2 text-sm text-red-600"
                                    id="status-error"
                                >
                                    {{ error(errors, "status") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="product_option_id"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Product
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <select
                                        v-model="inputs.product_option_id"
                                        :ref="refs.product_option_id"
                                        id="product_option_id"
                                        name="product_option_id"
                                        :class="[
                                            hasError(
                                                errors,
                                                'product_option_id',
                                            )
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-14'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(
                                                errors,
                                                'product_option_id',
                                            )
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(
                                                errors,
                                                'product_option_id',
                                            )
                                                ? 'product_option_id-error'
                                                : ''
                                        "
                                    >
                                        <option value="" selected>All</option>
                                        <option
                                            v-for="(
                                                productOption, productOptionId
                                            ) in productOptions"
                                            :key="productOptionId"
                                            :value="productOptionId"
                                        >
                                            {{ productOption }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="
                                            hasError(
                                                errors,
                                                'product_option_id',
                                            )
                                        "
                                        class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'product_option_id')"
                                    class="mt-2 text-sm text-red-600"
                                    id="product_option_id-error"
                                >
                                    {{ error(errors, "product_option_id") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="shipping_carrier"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Shipping Carrier
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <select
                                        v-model="inputs.shipping_carrier"
                                        :ref="refs.shipping_carrier"
                                        id="shipping_carrier"
                                        name="shipping_carrier"
                                        :class="[
                                            hasError(errors, 'shipping_carrier')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-14'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'shipping_carrier')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'shipping_carrier')
                                                ? 'shipping_carrier-error'
                                                : ''
                                        "
                                    >
                                        <option value="" selected>All</option>
                                        <option
                                            v-for="(
                                                shippingCarrierOption,
                                                shippingCarrierOptionId
                                            ) in shippingCarrierOptions"
                                            :key="shippingCarrierOptionId"
                                            :value="shippingCarrierOptionId"
                                        >
                                            {{ shippingCarrierOption }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="
                                            hasError(errors, 'shipping_carrier')
                                        "
                                        class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'shipping_carrier')"
                                    class="mt-2 text-sm text-red-600"
                                    id="shipping_carrier-error"
                                >
                                    {{ error(errors, "shipping_carrier") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="shipping_speed"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Shipping Speed
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <select
                                        v-model="inputs.shipping_speed"
                                        :ref="refs.shipping_speed"
                                        id="shipping_speed"
                                        name="shipping_speed"
                                        :class="[
                                            hasError(errors, 'shipping_speed')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-14'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'shipping_speed')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'shipping_speed')
                                                ? 'shipping_speed-error'
                                                : ''
                                        "
                                    >
                                        <option value="" selected>All</option>
                                        <option
                                            v-for="(
                                                shippingSpeedOption,
                                                shippingSpeedOptionId
                                            ) in shippingSpeedOptions"
                                            :key="shippingSpeedOptionId"
                                            :value="shippingSpeedOptionId"
                                        >
                                            {{ shippingSpeedOption }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="
                                            hasError(errors, 'shipping_speed')
                                        "
                                        class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'shipping_speed')"
                                    class="mt-2 text-sm text-red-600"
                                    id="shipping_speed-error"
                                >
                                    {{ error(errors, "shipping_speed") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="shipping_method_id"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Shipping Method
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <select
                                        v-model="inputs.shipping_method_id"
                                        :ref="refs.shipping_method_id"
                                        id="shipping_method_id"
                                        name="shipping_method_id"
                                        :class="[
                                            hasError(
                                                errors,
                                                'shipping_method_id',
                                            )
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-14'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(
                                                errors,
                                                'shipping_method_id',
                                            )
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(
                                                errors,
                                                'shipping_method_id',
                                            )
                                                ? 'shipping_method_id-error'
                                                : ''
                                        "
                                    >
                                        <option value="" selected>All</option>
                                        <option
                                            v-for="(
                                                shippingMethodOption,
                                                shippingMethodOptionId
                                            ) in shippingMethodOptions"
                                            :key="shippingMethodOptionId"
                                            :value="shippingMethodOptionId"
                                        >
                                            {{ shippingMethodOption }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="
                                            hasError(
                                                errors,
                                                'shipping_method_id',
                                            )
                                        "
                                        class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="
                                        hasError(errors, 'shipping_method_id')
                                    "
                                    class="mt-2 text-sm text-red-600"
                                    id="shipping_method_id-error"
                                >
                                    {{ error(errors, "shipping_method_id") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="packaging_type_id"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Packaging Type
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <select
                                        v-model="inputs.packaging_type_id"
                                        :ref="refs.packaging_type_id"
                                        id="packaging_type_id"
                                        name="packaging_type_id"
                                        :class="[
                                            hasError(
                                                errors,
                                                'packaging_type_id',
                                            )
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-14'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(
                                                errors,
                                                'packaging_type_id',
                                            )
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(
                                                errors,
                                                'packaging_type_id',
                                            )
                                                ? 'packaging_type_id-error'
                                                : ''
                                        "
                                    >
                                        <option value="" selected>All</option>
                                        <option
                                            v-for="(
                                                packagingTypeOption,
                                                packagingTypeOptionId
                                            ) in packagingTypeOptions"
                                            :key="packagingTypeOptionId"
                                            :value="packagingTypeOptionId"
                                        >
                                            {{ packagingTypeOption }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="
                                            hasError(
                                                errors,
                                                'packaging_type_id',
                                            )
                                        "
                                        class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'packaging_type_id')"
                                    class="mt-2 text-sm text-red-600"
                                    id="packaging_type_id-error"
                                >
                                    {{ error(errors, "packaging_type_id") }}
                                </p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label
                                    for="combined"
                                    class="block text-sm font-medium text-gray-700"
                                >
                                    Combined
                                </label>

                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <select
                                        v-model="inputs.combined"
                                        :ref="refs.combined"
                                        id="combined"
                                        name="combined"
                                        :class="[
                                            hasError(errors, 'combined')
                                                ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-14'
                                                : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                            'mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none sm:text-sm',
                                        ]"
                                        :aria-invalid="
                                            hasError(errors, 'combined')
                                                ? 'true'
                                                : 'false'
                                        "
                                        :aria-describedby="
                                            hasError(errors, 'combined')
                                                ? 'combined-error'
                                                : ''
                                        "
                                    >
                                        <option value="" selected>All</option>
                                        <option value="1">Yes</option>
                                    </select>
                                    <div
                                        v-if="hasError(errors, 'combined')"
                                        class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
                                    >
                                        <ExclamationCircleIcon
                                            class="h-5 w-5 text-red-500"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <p
                                    v-if="hasError(errors, 'combined')"
                                    class="mt-2 text-sm text-red-600"
                                    id="combined-error"
                                >
                                    {{ error(errors, "combined") }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sm:px-6 py-6 flex justify-center items-center">
                <div class="w-2/5 sm:w-1/3 pr-1 sm:pr-4">
                    <a
                        role="button"
                        href="/user/shipment-batches"
                        class="inline-flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm font-medium text-white bg-red-500 hover:bg-red-600 focus:outline-none w-full"
                    >
                        <XIcon class="h-5 w-5 mr-2" aria-hidden="true" />
                        Cancel
                    </a>
                </div>

                <div class="w-3/5 sm:w-2/3 pl-1 sm:pl-4">
                    <button
                        name="search"
                        type="submit"
                        class="inline-flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm font-medium text-white bg-nutreance-green hover:bg-nutreance-green-darker focus:outline-none w-full"
                    >
                        <SearchIcon class="h-5 w-5 mr-2" aria-hidden="true" />
                        Search
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { SearchIcon } from "@heroicons/vue/outline";
import { ExclamationCircleIcon, XIcon } from "@heroicons/vue/solid";
import { useForm } from "../../functions/useForm";
import Datepicker from "vue3-datepicker";
import { DateTime } from "luxon";

const props = defineProps<{
    csrf?: string;
    errors?: any;
    old?: any;
    packagingTypeOptions?: any;
    productOptions?: any;
    shippingCarrierOptions?: any;
    shippingSpeedOptions?: any;
    shippingMethodOptions?: any;
    statusOptions?: any;
}>();

const { error, hasError, oldInput, onSubmit } = useForm();
const form = ref<any>(null);

const refs = {
    status: ref<any>(null),
    start: ref<any>(new Date()),
    end: ref<any>(new Date()),
    product_option_id: ref<any>(null),
    shipping_carrier: ref<any>(null),
    shipping_speed: ref<any>(null),
    shipping_method_id: ref<any>(null),
    packaging_type_id: ref<any>(null),
    combined: ref<any>(null),
};

const inputs = reactive({
    status: oldInput(props.old, "status") ? oldInput(props.old, "status") : "",
    start: oldInput(props.old, "start")
        ? DateTime.fromISO(oldInput(props.old, "start")).toJSDate()
        : null,
    end: oldInput(props.old, "end")
        ? DateTime.fromISO(oldInput(props.old, "end")).toJSDate()
        : null,
    product_option_id: oldInput(props.old, "product_option_id")
        ? oldInput(props.old, "product_option_id")
        : "",
    shipping_carrier: oldInput(props.old, "shipping_carrier")
        ? oldInput(props.old, "shipping_carrier")
        : "",
    shipping_speed: oldInput(props.old, "shipping_speed")
        ? oldInput(props.old, "shipping_speed")
        : "",
    shipping_method_id: oldInput(props.old, "shipping_method_id")
        ? oldInput(props.old, "shipping_method_id")
        : "",
    packaging_type_id: oldInput(props.old, "packaging_type_id")
        ? oldInput(props.old, "packaging_type_id")
        : "",
    combined: oldInput(props.old, "combined")
        ? oldInput(props.old, "combined")
        : "",
});

onMounted(() => {
    switch (true) {
        case !!hasError(props.errors, "status"):
            return refs.status.value.focus();
        case !!hasError(props.errors, "product_option_id"):
            return refs.product_option_id.value.focus();
        case !!hasError(props.errors, "shipping_carrier"):
            return refs.shipping_carrier.value.focus();
        case !!hasError(props.errors, "shipping_speed"):
            return refs.shipping_speed.value.focus();
        case !!hasError(props.errors, "shipping_method_id"):
            return refs.shipping_method_id.value.focus();
        case !!hasError(props.errors, "packaging_type_id"):
            return refs.packaging_type_id.value.focus();
        case !!hasError(props.errors, "combined"):
            return refs.combined.value.focus();
        default:
            return refs.status.value.focus();
    }
});
</script>
